/**
 * SGKC011A
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface SlideadjustmentunitpriceLstInfoDto {

    /**
     * スライド調整単価コード
     */
    slideadjustmentunitpriceCode?: string;
    /**
     * スライド調整単価名称
     */
    slideadjustmentunitpriceAname?: string;
    /**
     * 適用年月
     */
    applyYm?: string;
    /**
     * 適用開始日付
     */
    applyStartDate?: string;
    /**
     * 適用終了日付
     */
    applyEndDate?: string;
    /**
     * スライド調整単価
     */
    slideadjustmentunitprice?: number;
    /**
     * 承認ステータスコード
     */
    apprvStatuscode?: string;
    /**
     * 承認ステータス名称
     */
    apprvStsAname?: string;
    /**
     * 旧新区分
     */
    oldnewdivision?: string;
    /**
     * スライド調整単価説明
     */
    slideadjustmentunitpriceExplanation?: string;
    /**
     * 適用開始年月
     */
    applyStartyearmonth?: string;
}

